import { useTrackEventForAdoption } from "src/query/adoption";
import { TrackEventForAdoptionRequest } from "src/types/adoption";
import {
  TRACK_NOTIFY_USERS_CLICKED_EVENT,
  TRACK_MANAGE_TECH_STACK_CLICKED_EVENT,
  TRACK_CONTENT_MODERATORS_ADDED_EVENT,
  TRACK_TECH_STACK_ADDED_EVENT
} from "src/constants/adoption/eventTypes";

import _ from "lodash";
import { SettingsModule } from "src/types/settings/common";


export const useDashboardAdoption = () => {
  const { mutate: trackEvent } = useTrackEventForAdoption(SettingsModule.DASHBOARD);

  const screenProperty = {
    "screen_name": "Settings"
  }

  const trackNotifyUsersClicked = () => {
    const event = {
      event: TRACK_NOTIFY_USERS_CLICKED_EVENT,
      properties: screenProperty,
    };
    trackEvent(event);
  };

  const trackManageTechStackClicked = () => {
    const event = {
      event: TRACK_MANAGE_TECH_STACK_CLICKED_EVENT,
      properties: screenProperty,
    };
    trackEvent(event);
  };

  const trackContentModeratorsAdded = () => {
    const event = {
      event: TRACK_CONTENT_MODERATORS_ADDED_EVENT,
      properties: screenProperty,
    };
    trackEvent(event);
  };

  const trackTechStackAdded = (techStackName: string) => {
    const event: TrackEventForAdoptionRequest = {
      event: TRACK_TECH_STACK_ADDED_EVENT,
      properties: {
        ...screenProperty,
        name: techStackName,
      },
    };
    trackEvent(event);
  };

  return {
    trackNotifyUsersClicked,
    trackManageTechStackClicked,
    trackContentModeratorsAdded,
    trackTechStackAdded
  };
};
